module.exports = __webpack_public_path__ + "static/Phresh Static bg-b7cdc33547932ba3215d422606662963.jpg";